import 'aos/dist/aos.css';
import propTypes from 'prop-types';
import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import { connect } from 'react-redux';
import { Link, Navigate } from 'react-router-dom';
import { setAlert } from '../../actions/alert';
import { guestRegister } from '../../actions/auth';
import logo from '../../images/showcase.jpg';

const GuestRegister = ({ guestRegister, isAuthenticated, setAlert }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        password2: ''
    });
    const { name, email, password, password2 } = formData;

    const onChange = e =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();
        
        if(password !== password2){
            setAlert('Passwords do not match', 'danger');
        }
        else{
            guestRegister({ name, email, password });
        }
    };

    // Navigate to HomeScreen if authenticated
    if(isAuthenticated) {
        return <Navigate to = '/homeScreen'/>
    }

  return (
    <section className='landing'>
    <div className="container" style={{ maxWidth: "500px"}}>
        <h5 className="text-light"><i className="fa-thin fa-hands-praying" /> &nbsp; Welcome, Guest</h5>
        <Card className='transbox' style={{ width: '100%' }} data-aos='zoom-in'>
            <Card.Header><h6 className="my-1"><i className="fa fa-user"></i> Register your account</h6></Card.Header>
            <Card.Body>
                <Card.Img variant="top" src={logo} style={{maxWidth: '500px'}}/>
                <form className="form" onSubmit={ e => onSubmit(e)}>
                    <div className="form-group">
                        <input type="text" placeholder="Name" name="name" required onChange={e => onChange(e)} />
                    </div>
                    <div className="form-group">
                        <input type="email" placeholder="Email Address" name="email" required onChange={e => onChange(e)} />
                    </div>
                    <div className="form-group">
                        <input
                            type="password"
                            placeholder="Password"
                            name="password"
                            minLength="8"
                            required
                            onChange={e => onChange(e)}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="password"
                            placeholder="Confirm Password"
                            name="password2"
                            minLength="8"
                            required
                            onChange={e => onChange(e)}
                        />
                    </div>
                    <input type="submit" className="btn btn-outline-primary" value="Register" style={{ float: "right"}} />
                </form>
            </Card.Body>
            <Card.Footer>
                <h6 className="my-1">
                    Already have an account? <Link to='/guestLogin'>Login</Link>
                </h6>
            </Card.Footer>
        </Card>
    </div>
    </section>
  )
};

GuestRegister.propTypes = {
    guestRegister: propTypes.func.isRequired,
    setAlert: propTypes.func.isRequired,
    isAuthenticated: propTypes.bool
};

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,    
});

export default connect(mapStateToProps, {guestRegister, setAlert})(GuestRegister);